import { User } from '@/models/User';

export interface CAUserState {
  user: User
}

export const USER_MUTATION_SET_USER: string = 'setUser';
